import emailSVG from '@shared/assets/svgs/email.svg';
import whatsAppSVG from '@shared/assets/svgs/whats-app.svg';
import smsSVG from '@shared/assets/svgs/sms.svg';
import { REMINDER_CHANNELS, type TReminder } from '@src/shared/types/reminder';

const CHANNELS_SVGS = {
  [REMINDER_CHANNELS.email]: emailSVG,
  [REMINDER_CHANNELS.whatsapp]: whatsAppSVG,
  [REMINDER_CHANNELS.sms]: smsSVG,
};

export const getChannelSvg = (channel: TReminder['notification_channel']) => {
  return CHANNELS_SVGS[channel];
};
